import React from "react";
import "./quicklinks.css";

export default function Quicklinks() {
  return (
    <div className="quicklinks3">
      <div className="quicklinkswrapper3">
        <div className="quicklinksheading3">QUICK LINKS</div>
        <div className="linkscontainer3">
          <div className="ontheleft">
            <a href="/home">Home</a>
            <a href="/products">Products</a>
            <a href="/portal">Portal</a>
            <a href="/account">Account</a>
          </div>
          <div className="onthecenter">
            <a href="/whyus">Why us</a>
            <a href="/services">Services</a>
            <a href="/contactus">Contactus</a>
            <a href="/contactus">Social media</a>
          </div>
          <div className="ontheright">
            <a href="/">Innovations</a>
            <a href="/">Careers</a>
            <a href="/">Terms</a>
            <a href="/">More</a>
          </div>
        </div>
      </div>
    </div>
  );
}
